import { Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import { memo } from 'react';
import ConfirmMsgDiv from './ConfirmMsgDiv';
import NgpThreeButtonDialog from '../dialog-three-button/NgpThreeButtonDialog';

const DisableDeleteActionDialog = ({ plural, open, setOpen, onConfirm, onDisable, confirmMsg, label }) => (
    <NgpThreeButtonDialog
        title={<Trans>Confirm {label}</Trans>}
        confirmButtonText={<Trans>{label}</Trans>}
        disableButtonText={<Trans>DISABLE</Trans>}
        cancelButtonText={<Trans>Cancel</Trans>}
        open={open}
        setOpen={setOpen}
        onConfirm={onConfirm}
        onDisable={onDisable}
        isWarning
        closeInTitleBar={false}
    >
        <ConfirmMsgDiv plural={plural} confirmMsg={confirmMsg} label={label} />
    </NgpThreeButtonDialog>
);

DisableDeleteActionDialog.propTypes = {
    plural: PropTypes.bool,
    open: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    setOpen: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onDisable: PropTypes.func.isRequired,
    confirmMsg: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
};

DisableDeleteActionDialog.defaultProps = {
    plural: false,
    confirmMsg: null,
};

DisableDeleteActionDialog.displayName = 'DisableDeleteActionDialog';

export default memo(DisableDeleteActionDialog);
